
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.2 11.97L9.264 1.644a1.682 1.682 0 00-2.283-.608 1.682 1.682 0 00-.614.609L.434 11.97a1.601 1.601 0 000 1.613 1.654 1.654 0 001.449.828H13.75a1.65 1.65 0 001.666-1.635c0-.283-.074-.562-.217-.806zM7.273 6.253a.545.545 0 01.926-.384c.102.102.16.24.16.384v2.72a.545.545 0 01-.927.385.545.545 0 01-.16-.385v-2.72zm.543 5.984a.813.813 0 01-.799-.975.817.817 0 01.64-.64.812.812 0 01.973.8.817.817 0 01-.814.815z","fill":"#910000"}})])
          )
        }
      }
    